import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/clinicalTrials';
import { actions } from './clinicalTrialsList.slice';
import { ClinicalTrialsListFetchAction } from './clinicalTrialsList.types';
import { Resp, dispatch } from '../helpers';

export function* fetchClinicalTrialsListWorker(
  action: ClinicalTrialsListFetchAction
) {
  try {
    const response: Resp<typeof api.fetchClinicalTrialsList> = yield call(
      api.fetchClinicalTrialsList,
      action.payload
    );

    yield dispatch(
      actions.fetchClinicalTrialsListSuccess(response?.data ?? {})
    );
  } catch (error) {
    yield dispatch(actions.fetchClinicalTrialsListFailure(error as Error));
  }
}

export function* clinicalTrialsListSaga() {
  yield takeLatest(
    actions.fetchClinicalTrialsList.type,
    fetchClinicalTrialsListWorker
  );
}
